var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('FoodTable'),_c('v-spacer'),_c('CreateFoodDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }